import {useQuery} from '@tanstack/react-query';

import {STORAGE_CROPS, StorageCrop, StorageCropId} from './data/storageAshTransport';

type Input = {
  areaHarvested?: number;
  cropId?: StorageCropId;
  mc?: number; // 1 to 100
};

type Output = {
  crop?: StorageCrop;
  cropWeightDried?: number;
  cropWeightTransported?: number;
  loads?: number;
};

export function calculateTransport({areaHarvested, cropId, mc}: Input): Output {
  const crop = cropId ? STORAGE_CROPS[cropId] : undefined;
  const cropWeightDried =
    crop !== undefined && areaHarvested !== undefined ? crop.driedYield * areaHarvested : undefined;
  const cropWeightTransported =
    cropWeightDried !== undefined && mc !== undefined ? cropWeightDried / (1 - mc / 100) : undefined;
  const loads =
    cropWeightTransported !== undefined && crop !== undefined ? cropWeightTransported / crop.weight : undefined;

  return {
    crop,
    cropWeightDried,
    cropWeightTransported,
    loads,
  };
}

export function useTransportCalculator(input: Input) {
  return useQuery({
    queryKey: [...Object.values(input)],
    queryFn: () => calculateTransport(input),
  });
}
